var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnToggleList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btnToggleList") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Grid-OFF-",
    transform: "translate(-32.000000, -21.000000)",
    fill: "#7BCB45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btnToggleList",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2058824,9 C38.3235294,9 37.4901961,9.49180328 37,10.2568306 C36.5098039,9.49180328 35.6764706,9 34.7941176,9 C33.2254902,9 32,10.3661202 32,12.1147541 C32,14.5737705 37,19 37,19 C37,19 42,14.5191257 42,12.1147541 C42,10.3661202 40.7254902,9 39.2058824,9 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnToggleList);
export default __webpack_public_path__ + "static/media/btnToggleList.44b721de7d4b4da82c836190910dcd56.svg";
export { ForwardRef as ReactComponent };